import { render } from "./Play.vue?vue&type=template&id=3588831f&scoped=true"
import script from "./Play.vue?vue&type=script&lang=ts"
export * from "./Play.vue?vue&type=script&lang=ts"

import "./Play.vue?vue&type=style&index=0&id=3588831f&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-3588831f"

export default script